import React, { useState } from "react";
import { MdKeyboardArrowDown, IoIosArrowForward } from "../utils/Icons";
import { allFilterText } from "../utils/OtherUtils";
import { useTestContext } from "../context/TestContext";
import { useNavigate } from "react-router-dom";

const filterRibbonData = ["Lab Tests", "Packages", "X-rays & Scans"];

const labTestCategory = [
  "Popular Lab Tests",
  "Risk-Based Testing",
  "Specialized Tests",
  "Super Specialty Tests",
];

const packageCategory = ["Popular Packages", "Full Body Packages"];

const xRayCategory = [
  "Digital X-rays",
  "Ultrasound",
  "X-rays & Scans Center",
  "More",
];

const ProductFilter = () => {
  const [isRibbonDropdown, setIsRibbonDropdown] = useState(false);
  const [selectedRibbonData, setSelectedRibbonData] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("Popular Lab Tests");
  const { setGlobalSearchQuery, handleAddProductsToBeSearched, fetchAllSearchedProducts, setFromProductFilter  } = useTestContext();
  const navigate = useNavigate();

  const handleRibbonOpen = (getData) => {
    setSelectedRibbonData(getData);

    if (getData === "Lab Tests") {
      setSelectedFilter("Popular Lab Tests");
    } else if (getData === "Packages") {
      setSelectedFilter("Popular Packages");
    } else if (getData === "X-rays & Scans") {
      setSelectedFilter("Digital X-rays");
    }

    setIsRibbonDropdown(true);
  };

  const handleRibbonClose = () => {
    setSelectedRibbonData("");
    setIsRibbonDropdown(false);
  };

  const handleFilterHover = (getFilter) => {
    setSelectedFilter(getFilter);
  };

  const handleFilterTextClick = async(getText) => {
    handleAddProductsToBeSearched([getText]);
    setFromProductFilter({status:true,text:getText});
    const queryParam = [getText].join('$');
    navigate(`/search?products=${encodeURIComponent(queryParam)}`);
  };
  

  return (
    <div className="w-full h-fit hidden lg:flex justify-start items-center border-b px-[12.5%] py-[0.3%] mb-[2%] relative">
      {filterRibbonData?.map((item, index) => (
        <button
          className={`flex items-center space-x-2 mr-[5%] font-medium text-[1.25vw] ${
            item === selectedRibbonData
              ? "text-primaryColor"
              : "text-textSecondaryColor"
          } hover:text-primaryColor whitespace-nowrap`}
          key={index}
          onMouseEnter={() => handleRibbonOpen(item)}
          //onMouseLeave={handleRibbonClose}
        >
          <span>{item}</span>
          <MdKeyboardArrowDown />
        </button>
      ))}
      {isRibbonDropdown && (
        <div className="h-[80vh] bg-black/50 px-[3%] pb-[3%] absolute left-0 top-9 right-0 z-50">
          <div
            className="h-full bg-whiteColor border-t-[3px] border-primaryColor rounded-b-3xl shadow-2xl"
            onMouseEnter={() => setIsRibbonDropdown(true)}
            onMouseLeave={handleRibbonClose}
          >
            <div className="w-full h-full flex justify-between items-start rounded-b-3xl">
              <div className="w-[20%] h-full flex flex-col justify-between bg-[#F1F1F1] rounded-bl-3xl p-[1%]">
                <div className="w-full h-fit space-y-[3%]">
                  {selectedRibbonData === "Lab Tests" &&
                    labTestCategory?.map((item, index) => (
                      <button
                        className="w-full h-fit flex justify-between items-center font-normal text-[0.9vw] text-textSecondaryColor hover:text-whiteColor hover:bg-primaryColor rounded-xl p-[3%]"
                        key={index}
                        onMouseEnter={() => handleFilterHover(item)}
                      >
                        <span>{item}</span>
                        <IoIosArrowForward />
                      </button>
                    ))}

                  {selectedRibbonData === "Packages" &&
                    packageCategory?.map((item, index) => (
                      <button
                        className="w-full h-fit flex justify-between items-center font-normal text-[0.9vw] text-textSecondaryColor hover:text-whiteColor hover:bg-primaryColor rounded-xl p-[3%]"
                        key={index}
                        onMouseEnter={() => handleFilterHover(item)}
                      >
                        <span>{item}</span>
                        <IoIosArrowForward />
                      </button>
                    ))}

                  {selectedRibbonData === "X-rays & Scans" &&
                    xRayCategory?.map((item, index) => (
                      <button
                        className="w-full h-fit flex justify-between items-center font-normal text-[0.9vw] text-textSecondaryColor hover:text-whiteColor hover:bg-primaryColor rounded-xl p-[3%]"
                        key={index}
                        onMouseEnter={() => handleFilterHover(item)}
                      >
                        <span>{item}</span>
                        <IoIosArrowForward />
                      </button>
                    ))}
                </div>
                <div className="w-full h-fit flex flex-col">
                  <span className="font-normal text-[1vw] text-textSecondaryColor">
                    We Have 12,000+ Tests
                  </span>
                  <span className="font-normal text-[1vw] text-textSecondaryColor">
                    For Better Result, Try Search
                  </span>
                </div>
              </div>
              {selectedFilter === "Risk-Based Testing" ? (
                <div className="w-[80%] h-fit grid grid-cols-1 gap-y-[5%] place-items-start p-[1%]">
                  {allFilterText[selectedFilter]?.map((item, index) => (
                    <button
                      className="font-normal text-[0.9vw] text-textSecondaryColor hover:text-primaryColor text-start"
                      key={index}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="w-[80%] h-fit grid grid-cols-3 gap-x-[2%] gap-y-[5%] place-items-start p-[1%]">
                  {allFilterText[selectedFilter]?.map((item, index) => (
                    <button
                      className="font-normal text-[0.9vw] text-textSecondaryColor hover:text-primaryColor text-start"
                      key={index}
                      onClick={() => handleFilterTextClick(item)}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductFilter;
